export enum StatementHolidayChildCareAnswerEnum {
    TwoCareDays = 'TwoCareDays',
    SixteenCareHours = 'SixteenCareHours'
  }